const TRADE_ID_SUFFIX_RE = /^([A-Za-z]+)_?(\d+)$/;

function normalizeTradeIdSortValue(value: unknown): string {
  return String(value ?? '').trim();
}

function splitTradeId(value: unknown): { prefix: string; numericSuffix: number; raw: string } | null {
  const raw = normalizeTradeIdSortValue(value);
  if (!raw) return null;

  const match = raw.match(TRADE_ID_SUFFIX_RE);
  if (!match) return null;

  const numericSuffix = Number(match[2]);
  if (!Number.isFinite(numericSuffix)) return null;

  return {
    prefix: match[1].toUpperCase(),
    numericSuffix,
    raw,
  };
}

function compareFallbackTradeIds(left: unknown, right: unknown): number {
  const a = normalizeTradeIdSortValue(left).toLowerCase();
  const b = normalizeTradeIdSortValue(right).toLowerCase();
  return a.localeCompare(b);
}

export function compareTradeIdValues(left: unknown, right: unknown): number {
  const parsedLeft = splitTradeId(left);
  const parsedRight = splitTradeId(right);

  if (!parsedLeft || !parsedRight) {
    return compareFallbackTradeIds(left, right);
  }

  if (parsedLeft.prefix !== parsedRight.prefix) {
    return compareFallbackTradeIds(parsedLeft.raw, parsedRight.raw);
  }

  if (parsedLeft.numericSuffix !== parsedRight.numericSuffix) {
    return parsedLeft.numericSuffix - parsedRight.numericSuffix;
  }

  return compareFallbackTradeIds(parsedLeft.raw, parsedRight.raw);
}
